export default __webpack_public_path__ + "static/media/DANGER.87f6d71a.png";